import { apiRequest } from '@/Groups/Signals/private/imports/externalUtils';

//Получить виджет сигналов
export const apiGetSignalsWidget = () =>
  apiRequest('/api/widgets/signals-widget/');